import { Container, Group, Loader, Text, useToast } from '@melio/penny';
import { useVendor, Vendor } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

import { useDisclosure } from '@/hooks/useDisclosure';
import { TaxPayerInfoCheckbox } from './components/TaxPayerInfoCheckbox.component';
import { RequestVendorTaxDetailsModal } from './RequestVendorTaxDetailsModal.widget';
import { TaxPayerInfoForm } from './TaxPayerInfoForm.widget';

type TaxPayerInfoCardProps = {
  vendor: Vendor;
};

export const TaxPayerInfoCard = ({ vendor }: TaxPayerInfoCardProps) => {
  const { formatMessage } = useMelioIntl();
  const { isMutating: isVendorMutating, update: updateVendor } = useVendor({ id: vendor['id'] });
  const toast = useToast();

  const {
    isOpen: isTaxRequestDetailsModalOpen,
    onOpen: openTaxRequestDetailsModal,
    onClose: closeTaxRequestDetailsModal,
  } = useDisclosure();

  const onContractorUpdate = async () => {
    try {
      await updateVendor({ contractor: !vendor.contractor });
    } catch (e) {
      toast({
        type: 'error',
        title: formatMessage('widgets.taxPayerInfo.vendorUpdate.fail.toast'),
      });
    }
  };

  const onSendRequest = async () => {
    if (vendor?.contact.email) {
      // To-DO: integrate API & send request
    } else {
      openTaxRequestDetailsModal();
    }
  };

  return (
    <Container data-testid="taxpayer-info-card">
      <Group variant="vertical" spacing="m">
        <Group justifyContent="space-between">
          <Text as="h3" textStyle="heading3Semi">
            {formatMessage('widgets.taxPayerInfo.title')}
          </Text>
        </Group>

        <Group spacing="m" hasDivider variant={'vertical'}>
          {isVendorMutating ? (
            <Loader />
          ) : (
            <TaxPayerInfoCheckbox
              isUpdating={isVendorMutating}
              onChange={onContractorUpdate}
              isContractor={vendor.contractor}
            />
          )}
          {vendor.contractor && <TaxPayerInfoForm handleSendClick={onSendRequest} />}
        </Group>
        <RequestVendorTaxDetailsModal
          isOpen={isTaxRequestDetailsModalOpen}
          onClose={closeTaxRequestDetailsModal}
          vendor={vendor}
        />
      </Group>
    </Container>
  );
};

TaxPayerInfoCard.displayName = 'TaxPayerInfoCard';
